
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiClearNight as ObiClearNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-clear-night.js';
 
 
 

 
 export const ObiClearNight = createComponent({
   react: React,
   tagName: 'obi-clear-night',
   elementClass: ObiClearNightElement,
   events: {
     
   }
  });
 
 